import { useMemo } from 'react'
import { Select } from '@workwhile/ui'
import { usePulseContext } from '../context/PulseProvider'
import { track } from 'lib/amplitude'

export function PositionTypesSelector() {
  const {
    state: { filters, positionTypes, isPositionTypesLoading },
    actions: { setFilters },
  } = usePulseContext()

  const selectedPositionTypes = useMemo(() => {
    const selectedPositionTypesSet = new Set(filters.positionTypes ?? [])
    return positionTypes?.filter((p) => selectedPositionTypesSet.has(p.value))
  }, [positionTypes, filters.positionTypes])

  return (
    <Select
      options={positionTypes}
      isMulti
      value={selectedPositionTypes}
      placeholder={
        selectedPositionTypes?.length > 0
          ? `${selectedPositionTypes.length} selected positions`
          : 'Filter by Position'
      }
      isClearable={true}
      onChange={(newValue) => {
        track('button_click, pulse_filter_position_type', {
          positionTypes: (newValue ?? []).map((v) => v.value),
        })
        setFilters({
          ...filters,
          positionTypes: (newValue ?? []).map((v) => v.value),
        })
      }}
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      controlShouldRenderValue={false}
      isLoading={isPositionTypesLoading}
    />
  )
}
